"use strict";

const Tabs = () => {
    const init = () => {
        window.refreshTabs = function(){
            var $tabsContainers = $('.js-tabs');
            if ($tabsContainers.length > 0) {
                $tabsContainers.each(function(){
                    var $tabsContainer = $(this);
                    var $tabs = $tabsContainer.find('.js-tabs-tab');
                    if($tabsContainer.data('type') !== undefined) {
                        var $pages = $tabsContainer.find('.js-tabs-page[data-type="'+$tabsContainer.data('type')+'"]');
                        var $images = $tabsContainer.find('.js-tabs-image[data-type="'+$tabsContainer.data('type')+'"]');
                    }else{
                        var $pages = $tabsContainer.find('.js-tabs-page');
                        var $images = $tabsContainer.find('.js-tabs-image');
                    }
                    var $select = $tabsContainer.find('.js-tabs-select');
                    
                    $tabs.on('click', function(){
                        var $tab = $(this);
                        $tab.siblings('.js-tabs-tab').removeClass('active');
                        $tab.addClass('active');
                        $pages.removeClass('active');
                        var $page = $pages.filter('[data-id="'+$tab.data('id')+'"]');
                        $page.addClass('active');
                        $images.hide();
                        var $image = $images.filter('[data-id="'+$tab.data('id')+'"]');
                        $image.show();
                        $select.val($tab.data('id'));
                        $select.niceSelect('update');

                        if($tab.data('link') !== undefined){
                            var form_data = $('.js-clear-on-load').serialize().replace("page=1", "").replace("lot_width_min=&", "").replace("lot_width_max=&", "").replace("&endparams=", "");
                            var url = $tab.data('link');

                            if(form_data.length > 0) {
                                url = url + '?' + form_data
                            }
                            $tabsContainer.find('a').attr('href', url);
                        }
                    });
                    
                    if($tabs.filter('.js-tabs-starts-active').length > 0){
                        $tabs.filter('.js-tabs-starts-active').trigger('click');
                    }else{
                        $tabs.filter(':first-child').trigger('click');
                    }
                    
                    $select.on('change', function(){
                        $tabs.filter('[data-id="'+$(this).val()+'"]').trigger('click');
                        $(this).niceSelect('update');
                    });
                })
            }
        }

        window.clickTab = function($tab){
            var $tabsContainer = $tab.closest('.js-tabs');
            if($tabsContainer.data('type') !== undefined) {
                var $pages = $tabsContainer.find('.js-tabs-page[data-type="'+$tabsContainer.data('type')+'"]');
                var $images = $tabsContainer.find('.js-tabs-image[data-type="'+$tabsContainer.data('type')+'"]');
            }else{
                var $pages = $tabsContainer.find('.js-tabs-page');
                var $images = $tabsContainer.find('.js-tabs-image');
            }
            var $images = $tabsContainer.find('.js-tabs-image');
            $tab.siblings().removeClass('active');
            $tab.addClass('active');
            $pages.removeClass('active');
            var $page = $pages.filter('[data-id="'+$tab.data('id')+'"]');
            $page.addClass('active');
            $images.hide();
            var $image = $images.filter('[data-id="'+$tab.data('id')+'"]');
            $image.show();

            if($tab.data('link') !== undefined){
                var form_data = $('.js-clear-on-load').serialize().replace("page=1", "").replace("lot_width_min=&", "").replace("lot_width_max=&", "").replace("&endparams=", "");
                var url = $tab.data('link');

                if(form_data.length > 0) {
                    url = url + '?' + form_data
                }
                $tabsContainer.find('a').attr('href', url);
            }
        }

        $(function() {
            refreshTabs();
        });
    };

    return {
        init:init
    };
};

export default Tabs;